import { useState, useEffect } from 'react';

/**
 * 작성 셸(ComposeWritePageShell/ComposePreviewView)의 sticky 헤더 top 오프셋(px)을 계산한다.
 *
 * 앱 헤더(Layout의 모바일/태블릿 sticky 헤더, h-14=56px)가 있는 lg 미만에서는 그 아래에 붙도록
 * 56px, 앱 헤더가 없는 lg+ 데스크톱에서는 0. StickyHeader의 `top-14 lg:top-0`(lg=1024px)과 동형.
 * rc 패키지는 앱 레이아웃을 모르므로 web이 이 값을 소유해 셸에 stickyTopOffset으로 전달한다.
 */
const LG_QUERY = '(min-width: 1024px)';
const APP_HEADER_PX = 56;

export function useStickyChromeTop(): number {
  const [top, setTop] = useState<number>(() =>
    typeof window === 'undefined' || window.matchMedia(LG_QUERY).matches ? 0 : APP_HEADER_PX,
  );

  useEffect(() => {
    const mq = window.matchMedia(LG_QUERY);
    const update = () => setTop(mq.matches ? 0 : APP_HEADER_PX);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return top;
}

export default useStickyChromeTop;
